import createReactComponent from '../createReactComponent';
var BellOff = createReactComponent('BellOff', [['path', {
  d: 'M13.73 21a2 2 0 01-3.46 0',
  key: '1kkhxe'
}], ['path', {
  d: 'M18.63 13A17.888 17.888 0 0118 8',
  key: 'en5z5i'
}], ['path', {
  d: 'M6.26 6.26A5.86 5.86 0 006 8c0 7-3 9-3 9h14',
  key: '11ycc0'
}], ['path', {
  d: 'M18 8a6 6 0 00-9.33-5',
  key: '1rc62v'
}], ['path', {
  d: 'M2 2l20 20',
  key: '48x37f'
}]]);
export default BellOff;